import { render, staticRenderFns } from "./FieldColumnList.vue?vue&type=template&id=7af24ee6&scoped=true&"
import script from "./FieldColumnList.vue?vue&type=script&lang=js&"
export * from "./FieldColumnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af24ee6",
  null
  
)

export default component.exports